import { I18n } from "@assets/strings";
import React from "react";
import { Group } from "@domain/group/group";
import { useSuggestedGroups } from "@domain/group/hooks";
import { Carousel } from "@ui/components/carousel/carousel";
import { DiscussionThumbnailSmall } from "@ui/components/group/discussionThumbnailSmall";

type FeedGroupSuggestionsProps = React.HTMLAttributes<HTMLDivElement>;
export const FeedGroupSuggestions: React.FC<FeedGroupSuggestionsProps> = ({ ...htmlProps }) => {
	const { result, loading } = useSuggestedGroups(5, "DISCUSSION_GROUP");
	const suggestedOpenDiscussions = result.filter((suggestion) => suggestion.accessMode === "OPEN");

	return suggestedOpenDiscussions.length > 0 ? (
		<Carousel
			{...htmlProps}
			style={{ marginTop: 20 }}
			title={I18n.t("feed.suggestions.groups")}
			items={suggestedOpenDiscussions}
			renderItem={(group) => <DiscussionThumbnailSmall key={group.id} discussion={group as Group} />}
			loading={loading}
		/>
	) : null;
};
